import axios from "axios";
import API_URLS from "./config/api";

const api = axios.create({
  baseURL: API_URLS.current,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getAccountInfo = () => api.get("/api/trading/account").then((res) => res.data.data);
export const getHoldings = () => api.get("/api/trading/holdings").then((res) => res.data.data);
export const getTrades = (params: Record<string, unknown>) =>
  api.get("/api/trades", { params }).then((res) => res.data.data.trades);
export const getTradeSummary = (params: Record<string, unknown>) =>
  api.get("/api/trades/summary", { params }).then((res) => res.data.data);
export const getModels = () => api.get("/api/models").then((res) => res.data.data);
export const getModelById = (id: string | number) => api.get(`/api/models/${id}`).then((res) => res.data.data);
export const applyModel = (id: string | number) => api.post(`/api/models/${id}/apply`).then((res) => res.data);
export const deactivateModel = (id: string | number) =>
  api.post(`/api/models/${id}/deactivate`).then((res) => res.data);
export const getAutomatedTradingStatus = () => api.get("/api/automated-trading/status").then((res) => res.data.data);
export const startAutomatedTrading = () => api.post("/api/automated-trading/start").then((res) => res.data);
export const stopAutomatedTrading = () => api.post("/api/automated-trading/stop").then((res) => res.data);
export const getTradingConfig = () => api.get("/api/automated-trading/config").then((res) => res.data.data);
export const updateTradingConfig = (config: Record<string, unknown>) =>
  api.post("/api/automated-trading/config", config).then((res) => res.data.data);
export const getTickers = () => api.get("/api/automated-trading/tickers").then((res) => res.data.data);
export const getRateLimitStatus = () => api.get("/api/automated-trading/rate-limit").then((res) => res.data.data);
export const getAuthStatus = () => api.get("/api/auth/zerodha/status").then((res) => res.data);
export const getLoginUrl = () => api.get("/api/auth/zerodha/login-url").then((res) => res.data);
export const logout = () => api.post("/api/auth/zerodha/logout").then((res) => res.data);
export const runBacktest = (params: Record<string, unknown>) =>
  api.post("/api/backtest/run", params).then((res) => res.data.data);
export const getBacktestHistory = () => api.get("/api/backtest/history").then((res) => res.data.data);
export const getBacktestResult = (id: string | number) => api.get(`/api/backtest/${id}`).then((res) => res.data.data);
export const getAutonomousStatus = () => api.get("/api/autonomous/status").then((res) => res.data.data);
export const startAutonomousTrading = (modelId: string | number) =>
  api.post(`/api/autonomous/start/${modelId}`).then((res) => res.data);
export const stopAutonomousTrading = (modelId: string | number) =>
  api.post(`/api/autonomous/stop/${modelId}`).then((res) => res.data);
export const getPortfolioStatus = (modelId: string | number) =>
  api.get(`/api/autonomous/portfolio/${modelId}`).then((res) => res.data.data);
export const getPerformanceMetrics = (modelId: string | number, period = "1d") =>
  api.get(`/api/autonomous/performance/${modelId}?period=${period}`).then((res) => res.data.data);
export default api;
